export const DEFAULTS = {
  step1: {
    producer: "",
    agentEmail: "",
    policyDate: undefined,
    insuredState: "",
    allowedCarriers: [],
    carrier: [],
    quoteType: "personal_auto",
  },
  step2: {
    firstName: "",
    lastName: "",
    dateOfBirth: undefined,
    gender: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    movedRecently: false,
    priorAddress: "",
    priorCity: "",
    priorState: "",
    priorZip: "",
  },
  step3: {
    vehicles: [],
  },
  step4: {
    drivers: [],
  },
  step5: {
    priorInsuranceStatus: "",
    priorInsuranceCarrier: "",
    bodilyInjuryLimits: "",
    yearsWithCarrier: "",
    driversListed: true,
    pipClaims: "",
    totalResidents: "",
    primaryResidence: "",
    rentersDiscount: false,
  },
  step6: {
    bodilyInjury: "",
    umbi: false,
    umPropertyDamage: "",
    medPay: "",
    pip: "",
    compDeductible: "",
    collisionDeductible: "",
    paymentPlan: "",
    runClue: false,
  },
};

export const RENTERS_DEFAULTS = {
  step1: {
    producer: "",
    agentEmail: "",
    policyDate: undefined,
    insuredState: "",
    allowedCarriers: [],
    carrier: [],
    quoteType: "renters",
  },
  step2: {
    firstName: "",
    lastName: "",
    dateOfBirth: undefined,
    gender: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    movedRecently: false,
    priorAddress: "",
    priorCity: "",
    priorState: "",
    priorZip: "",
    residenceType: "",
    hasRestrictedDogs: false,
    personalPropertyAmount: "",
    demographicFirstName: "",
    demographicLastName: "",
    demographicMaritalStatus: "",
    demographicDateOfBirth: undefined,
    demographicGender: "",
    additionalFirstName: "",
    additionalLastName: "",
    additionalMaritalStatus: "",
    additionalRelationship: "",
    additionalSecondNamedInsured: false,
    additionalDateOfBirth: undefined,
    additionalGender: "",
  },
  step3: {
    priorCarrier: "",
    priorLiabilityLimit: "",
    reportedClaims: "",
  },
  step4: {
    liabilityLimit: "",
    medicalPaymentsLimit: "",
    deductible: "",
    theftSublimit: "",
    homeComputerCoverage: "",
    paymentPlan: "",
    runClue: false,
  },
};
